module.exports = __webpack_public_path__ + "static/media/image-7.a22fd663.webp";